<template>
  <article class="card card--active" data-cy="article">
    <img class="card__image" :src="icon" aria-hidden="true" />
    <div class="card__text">
      <h3 class="card__title" v-if="title">{{ title }}</h3>
      <p class="card__description" v-if="description">{{ description }}</p>
      <p class="card__description" v-if="showAsDisabled">
        {{ t('shop.bookableLaterShort') }}
      </p>
    </div>
    <PlanPrice
      class="card__price"
      v-if="price"
      :amount="`${price} €`"
      :cadence="cadence"
    />
    <router-link v-if="link" :to="link" class="card__button">
      <caret :extraClasses="['card__icon']" direction="right" />
      <span class="visually-hidden">{{ t('shop.detailsAriaLabel') }}</span>
    </router-link>
  </article>
</template>

<script setup>
  import { computed } from 'vue'
  import { useStrings } from '@/composables/useStrings.ts'
  import Caret from '@/components/icons/Caret.vue'
  import PlanPrice from '@/components/shop/PlanPrice.vue'

  const { t } = useStrings()

  const props = defineProps({
    title: { type: String },
    description: { type: String },
    price: { type: String },
    link: { type: String },
    icon: { type: String },
    showAsDisabled: { type: Boolean },
    articleType: { type: Number, default: 1 },
  })

  const cadence = computed(() =>
    props.articleType === 2 ? undefined : t('shop.month')
  )
</script>

<style lang="scss" scoped>
.card {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: $spacer10;
  background-color: $grey-lightest;
}

.card__text {
  flex-grow: 1;
}

.card__price {
  margin-left: $spacer10;
  flex-shrink: 0;
  font-size: $font-size-lg;

  @media (min-width: $bp-ssm) {
    font-size: $font-size-xl;
    margin-left: $spacer10;
  }
}

.card__icon {
  width: 2.4rem;
}
.card__description {
  margin-bottom: 0;
  color: $grey-darker;
  font-size: 0.9em;
}

.card__title {
  margin-bottom: 0;
  font-size: $font-size-base;
  line-height: $line-height-sm;

  @media (min-width: $bp-ssm) {
    font-size: $font-size-lg;
  }
}

.card__image {
  height: 2rem;
  margin-right: $spacer05;

  @media (min-width: $bp-ssm) {
    height: 3rem;
    margin-right: $spacer20;
  }
}

.card__button {
  position: static;
  display: flex;
  margin-left: $spacer05;
  width: $spacer20;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>